// Orgs que usam o Relatório Squad ("Dashboard") como painel inicial.
// A métrica funnel_stage-alvo de cada org é resolvida no backend (RPCs
// relatorio_squad_*, que leem o stage_id do source_config da métrica ativa da
// org) — este mapa é só marca (label) + gating de rota/sidebar no frontend.
export const SQUAD_ORGS: Record<string, { label: string }> = {
  'a6a08a3e-5831-4349-a748-6a123ceebb75': { label: 'Alivvi' },
  'ecf15fbd-8eb1-443e-8f4a-362848a4b868': { label: 'Norte Auxílio' },
  '1bbd937b-a69c-4e34-8a2a-fb00c07bbd93': { label: 'Apoio Justo' },
  'c54e8b70-34bd-45f9-96ba-2158eec2faff': { label: 'Amparvida' },
};

export const SQUAD_ORG_IDS = Object.keys(SQUAD_ORGS);

/**
 * Unidade (business_unit) da Supervisão que hospeda o Relatório Squad CONSOLIDADO
 * (aba "Jurídico"). Soma os SQUAD_ORGS acima. Usado para gatear a aba na sidebar e
 * como p_business_unit_id (guard is_bu_supervisor) dos RPCs *_consolidated.
 */
export const KATETO_BUSINESS_UNIT_ID = '584ba2a0-12f0-4ffd-b582-29eaac51b563';

/** True se a org usa o Relatório Squad como dashboard inicial. */
export function isSquadOrg(orgId: string | null | undefined): boolean {
  return !!orgId && orgId in SQUAD_ORGS;
}

/** Rótulo de marca da org no relatório (fallback = nome da org / 'Squad'). */
export function squadLabel(orgId: string | null | undefined, fallback?: string | null): string {
  return (orgId ? SQUAD_ORGS[orgId]?.label : undefined) ?? fallback ?? 'Squad';
}
